import Business from "./Business";

const BusinessComponent = () => {
  return <Business />;
};

export default BusinessComponent;
